import React from "react";
import { connect } from "react-redux";

import Entities from "../common/Entities";
import EditModal from '../callback/Edit';
import CallbackTable from '../callback/CallbackTable';

import {
    fetchCallbackEnquiry as fetchCallbackEnquiryAction,
    updateCallback as updateCallbackAction,
    clearUpdateCallback as clearUpdateCallbackAction
} from '../../actions/callback';

let EnquiriesTab = class extends React.Component {
    constructor(props) {
        super(props);

        this._loadCallbacks = this._loadCallbacks.bind(this);
        this._updateCallback = this._updateCallback.bind(this);
        this._clearUpdateCallback = this._clearUpdateCallback.bind(this);
    }

    componentDidMount() {
        this._loadCallbacks();
    }

    _loadCallbacks() {
        this.props.fetchCallbackEnquiryAction();
    }

    _updateCallback(callbackEntity) {
        this.props.updateCallbackAction(callbackEntity);
    }

    _clearUpdateCallback() {
        this.props.clearUpdateCallbackAction();
    }

    render() {
        const {
            callbacks,
            updateFetching,
            updateResult,
            fetching,
            updateError
        } = this.props;

        return (
            <Entities
                entities={callbacks}
                fetching={fetching}
                contentTable={CallbackTable}
                editModal={EditModal}
                updateFetching={updateFetching}
                updateResult={updateResult}
                loadAction={this._loadCallbacks}
                updateAction={this._updateCallback}
                clearCrudAction={this._clearUpdateCallback}
                canCreate={false}
                header='Новые заявки'
                updateError={updateError}
            />
        );
    }

}

EnquiriesTab = connect(state => {
    const callbacks = state.application.get("callbacks");
    return {
        callbacks: callbacks.enquiries,
        fetching: callbacks.fetching,
        updateFetching: callbacks.updateFetching,
        updateResult: callbacks.updateResult,
        updateError: callbacks.updateError
    };
}, {
    fetchCallbackEnquiryAction,
    updateCallbackAction,
    clearUpdateCallbackAction
})(EnquiriesTab);

export default EnquiriesTab;


// WEBPACK FOOTER //
// ./src/components/callback/EnquiriesTab.jsx